<template>
  <v-container fluid>
    <v-layout>
      <h1 class="mb-3">
        Flow Builder
        <b>({{ bot.botTitle }})</b>
        <v-chip v-clipboard:copy="bot.botId" class="cursor-pointer ml-4" v-clipboard:success="onCopy">
            {{ bot.botId }} <v-icon small class="pl-2">file_copy</v-icon>
        </v-chip>
      </h1>
    </v-layout>
    <v-layout class="mt-2">
      <v-flex md4>
        <v-autocomplete
          v-model="selectedBlock"
          :items="blocksList"
          item-text="name"
          item-value="id"
          @change="updateSelectedBlock"
          solo
          label="Search Blocks"
          prepend-inner-icon="search"
          :return-object="true"
        >
        </v-autocomplete>
        <groups></groups>
      </v-flex>
      <v-flex
        md8
        class="pl-5"
        style="height: calc(100vh - 175px); overflow: auto"
      >
        <blocks :blocks-list="blocksList"></blocks>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import blocks from "../components/block-build/blocks/blocks";
import groups from "../components/block-build/groups/groups";
export default {
  components: {
    groups,
    blocks,
  },
  data() {
    return {
      bots: [],
      blocksList: [],
      selectedBlock: {},
      selectedOnce: false,
    };
  },
  async mounted() {
    await this.getBlocksList();
    await this.getVariables();
    await this.getSettings();
  },
  methods: {
    async getBlocksList() {
      const response = await this.$http_bot.get("/blocks");

      this.blocksList = response.data;
      if (this.$route.query.block) {
        this.updateSelectedQueryBlock();
      }
    },
    async getSettings() {
      const response = await this.$http_bot.get("/settings/");

      this.settings = response.data;
      if (!this.settings.nlp) {
        this.settings.nlp = {};
      }
      this.$store.dispatch("setSettings", this.settings);
    },
    async getVariables() {
      const response = await this.$http_bot.get("/blocks/variables/available");
      const variables = [];
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].variable !== "") {
          variables.push(response.data[i]);
        }
      }
      variables.push("channel");
      this.$store.dispatch("setVariables", variables);
    },
    updateSelectedBlock() {
      if (this.selectedBlock && this.selectedBlock.id)
        this.$store
          .dispatch("setSelectedBlock", this.selectedBlock)
          .then(() => {
            this.selectedOnce = true;
          });
    },
    updateSelectedQueryBlock() {
      setTimeout(() => {
        const filtered = this.blocksList.filter(
          (i) => i.id == this.$route.query.block
        );
        if (filtered && filtered.length) {
          // console.log('update')
          this.selectedBlock = filtered[0];
          this.$store.dispatch("setSelectedBlock", this.selectedBlock);
        } // console.log('refused')
      }, 200);
    },
    onCopy() {
        this.$store.dispatch("setSnackbar", {
            text: "Text copied to your clipboard",
            color: "primary",
            status: true,
        });
    },
  },
  computed: {
    bot() {
        return this.$store.state.bot;
    },
    selectedBlockState() {
      return this.$store.state.blocksBuild.selectedBlock;
    },
    newBlock() {
      return this.$store.state.blocksBuild.newBlock;
    },
    deletedBlock() {
      return this.$store.state.blocksBuild.deletedBlock;
    },
    editedBlock() {
      return this.$store.state.blocksBuild.updatedBlockName.name;
    },
  },
  watch: {
    selectedBlockState(state) {
      if (!state || state.id !== this.selectedBlock.id) {
        this.selectedBlock = {};
      }
    },
    newBlock(state) {
      if (state) {
        this.getBlocksList();
      }
    },
    editedBlock(state) {
      if (state) {
        this.getBlocksList();
      }
    },
    deletedBlock(state) {
      if (state) {
        this.getBlocksList();
      }
    },
  },
};
</script>
